export const ServiceMethods = function() {
  return {
    saveAndGetList: {
      method: "POST",
      isArray: true,
    },
    saveAndGetObject: {
      method: "POST",
      isArray: false,
    },
  };
};
export const searchForThisCriteria = function($resource, ServiceMethods) {
  return $resource(
    "restServices/wsapi/searchForThisCriteria",
    {},
    ServiceMethods
  );
};

export const calculateForECHS = function($resource, ServiceMethods) {
  return $resource("restServices/wsapi/calculateForECHS", {}, ServiceMethods);
};

export const analyseSkills = function($resource, ServiceMethods) {
  return $resource("restServices/wsapi/analyseSkills", {}, ServiceMethods);
};

export const analyseGear = function($resource, ServiceMethods) {
  return $resource("restServices/wsapi/analyseGear", {}, ServiceMethods);
};

export const getTroopNamesForThisrace = function($resource, ServiceMethods) {
  return $resource(
    "restServices/wsapi/getTroopNamesForThisrace",
    {},
    ServiceMethods
  );
};

export const getLogin = function($resource, ServiceMethods) {
  return $resource("restServices/wsapi/login", {}, ServiceMethods);
};

export const getAccountsResource = function($resource, ServiceMethods) {
  return $resource("restServices/wsapi/getaccounts", {}, ServiceMethods);
};

export const addAccountResource = function($resource, ServiceMethods) {
  return $resource("restServices/wsapi/addaccount", {}, ServiceMethods);
};

export const removeAccountResource = function($resource, ServiceMethods) {
  return $resource("restServices/wsapi/removeaccount", {}, ServiceMethods);
};

export const addServerToAccountRes = function($resource, ServiceMethods) {
  return $resource("restServices/wsapi/addservertoaccount", {}, ServiceMethods);
};

export const removeServerFromAccount = function($resource, ServiceMethods) {
  return $resource(
    "restServices/wsapi/removeserverfromaccount",
    {},
    ServiceMethods
  );
};

export const getAccountDetailsRes = function($resource, ServiceMethods) {
  return $resource("restServices/wsapi/getaccountdetails", {}, ServiceMethods);
};

export const doTaskActionRes = function($resource, ServiceMethods) {
  return $resource("restServices/wsapi/dotaskaction", {}, ServiceMethods);
};

export const GetPublicDataRes = function($resource, ServiceMethods) {
  return $resource("restServices/wsapi/getpublicdata", {}, ServiceMethods);
};

export const GetFileRes = function($resource, ServiceMethods) {
  return $resource("restServices/wsapi/download/text", {}, ServiceMethods);
};
